import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Integraciones() {
  const navigate = useNavigate()
  useEffect(() => { navigate('/sesiones', { replace: true }) }, [navigate])
  return null
}
